import React from 'react';
import {useState} from 'react';
import classNames from 'classnames';
import {Flex, Text, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {Initials, LogChangeItem} from './ListComponents';
import styles from '../styles/historyContent.module.scss';
import {ChangeFields} from '../consts';
import {getFieldValueByName} from '../../Common/utils';
import {Record} from '../../../../../../stores/Form/Record';
import {highlightText} from '../../../../../../_legacy/library/utils/highlightText';
import {DetailsContent} from '../../Common/components/DetailsContent';
import {createDataTestId} from '../../../../../../utils/dataTestId';

interface ChangeLogProps {
    log: Record;
    searchQuery: string;
    isLegacyStore: boolean;
    enabledCols: string[];
}

export const ChangeLog = ({log, searchQuery, isLegacyStore, enabledCols}: ChangeLogProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const userName = getFieldValueByName(log, ChangeFields.Signature);
    const initials = userName && userName[0].toUpperCase();
    const form = getFieldValueByName(log, ChangeFields.Form) as string;
    const column = getFieldValueByName(log, ChangeFields.Field);
    const prevValue = getFieldValueByName(log, ChangeFields.PrevValue);
    const currValue = getFieldValueByName(log, ChangeFields.CurrValue);
    const time = getFieldValueByName(log, ChangeFields.Date) as string;
    const details = getFieldValueByName(log, ChangeFields.Details) as string;
    const userFieldId = log.parentForm.getColumnByName(ChangeFields.Signature)?.ID;

    return (
        <div className={styles.listItemWrapper}>
            <Flex
                componentClasses={classNames(styles.statusListItem, {[styles.openDetails]: isOpen})}
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                <Initials initials={initials} />
                <Flex
                    direction="column"
                    componentClasses={styles.statusData}
                    alignItems="flex-start"
                >
                    <LogChangeItem
                        userName={userName}
                        column={column}
                        prevValue={prevValue}
                        currValue={currValue}
                        searchQuery={searchQuery}
                        isLegacyStore={isLegacyStore}
                        userFieldId={userFieldId}
                    />
                    <Flex
                        componentClasses={styles.footer}
                        justifyContent="flex-start"
                        {...createDataTestId(`log-details`, true)}
                    >
                        <Text skin="label-1" textColor="secondary-500">
                            {highlightText(form, searchQuery)}
                        </Text>
                        {details && (
                            <Text skin="label-1" textColor="secondary-500">
                                ({highlightText(details, searchQuery)})
                            </Text>
                        )}
                        {(form || details) && <div className={styles.separator} />}
                        <Text skin="label-1" textColor="secondary-500">
                            {highlightText(time, searchQuery)}
                        </Text>
                    </Flex>
                </Flex>
                {!!enabledCols.length && (
                    <Icon
                        icon={isOpen ? PriorityIcon.arrowUpThin : PriorityIcon.arrowBottom}
                        iconColor="secondary-400"
                        onClick={() => setIsOpen(prev => !prev)}
                        componentClasses={styles.detailsBtn}
                    />
                )}
            </Flex>
            {isOpen && <DetailsContent enabledCols={enabledCols} record={log} />}
        </div>
    );
};
